import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import Loader from '../loader';
import Modal from '../../components/modal';
import Button from '../../components/button/button';
import { getCurrentProduct, showHideElement, clearSessionStorage } from '../../app-actions';
import {
  SESSION_RENEWAL_INPROGRESS_TEXT,
  SESSION_RENEWAL_COMPLETE_TEXT,
  SESSION_RENEWAL_FAILED_TEXT,
  CIP_LOGOUT_URL,
  SECURE_AUTH_PARTNER_BY_PASS,
} from '../../app-constants';
import { apiGetWithoutDispatchWithoutHeaders } from '../../api/api-configuration';

import { customStylesDesktop } from '../../components/business-case-delete-modal/modal-styles-config';

class DataBootStrapView extends Component {
  componentDidMount() {
    console.log('partner view:', this.props.partnerView);
    const locationHash = window.location.hash;
    const { isAuthenticated } = this.props.authentication;
    const { cipLogoutUrl, sessionTimeOutMinutes, cipLoginUrlForRenew, sessionRenewalMinutes } = this.props;
    const { getCustomerDetails, setRedirectToLogoutAutomatically, setupSilentRenew } = this.props.actions;
    if (this.props.vantage) {
      const { getVantage } = this.props.actions;
      getVantage(locationHash);
    } else if (this.props.hostedMigration) {
      const { getHostedMigration } = this.props.actions;
      getHostedMigration(locationHash);
    } else if (this.props.businessPopMail) {
      const { getBusinessPopMail } = this.props.actions;
      getBusinessPopMail(locationHash);
    } else if (this.props.adaptiveMobilityExternal) {
      const { getAdaptiveMobilityExternal } = this.props.actions;
      getAdaptiveMobilityExternal(locationHash);
    } else if (this.props.partnerView) {
      const { secureAuthAuthenticated } = this.props;
      const ipData = sessionStorage.getItem('ipData');
      if (secureAuthAuthenticated && ipData == null) {
        const productType = getCurrentProduct();
        const renewalInterval = 8 * 60 * 1000; // 8 minutes
        const { setupSecureAuthTokenRenewal } = this.props.actions;
        if (SECURE_AUTH_PARTNER_BY_PASS === false) {
          setInterval(() => {
            setupSecureAuthTokenRenewal();
          }, renewalInterval);
        }
        apiGetWithoutDispatchWithoutHeaders('https://ipinfo.io?token=9e97bfb00cc1ef')
          .then((response) => {
            sessionStorage.setItem('ipData', JSON.stringify(response));
            if (productType === 'AMP') {
              const { getAMPCustomerData } = this.props.actions;
              getAMPCustomerData();
            }
          });
      } else if (SECURE_AUTH_PARTNER_BY_PASS) {
        apiGetWithoutDispatchWithoutHeaders('https://ipinfo.io?token=9e97bfb00cc1ef')
          .then((response) => {
            const productType = getCurrentProduct();
            sessionStorage.setItem('ipData', JSON.stringify(response));
            if (productType === 'AMP') {
              const { getAMPCustomerData } = this.props.actions;
              setTimeout(() => {
                getAMPCustomerData();
              }, 1000);
            }
          });
      }
    } else if (!isAuthenticated && window === window.parent) { // only for the main window, not for iframe used for renewal
      getCustomerDetails({ locationHash });
      setRedirectToLogoutAutomatically(sessionTimeOutMinutes, cipLogoutUrl);
      setupSilentRenew(cipLoginUrlForRenew, window.location.hash, sessionRenewalMinutes);
    }
  }

  componentDidUpdate(prevProps) {
    console.log('in data bootstrap component did update');
    if (window === window.parent && prevProps.authentication.isAuthenticated !== this.props.authentication.isAuthenticated) {
      console.log('only in main app window');
      const productType = getCurrentProduct();
      if (productType === 'SSM') {
        const { getSSMCustomerData } = this.props.actions;
        getSSMCustomerData();
      } else if (productType === 'MBS') {
        const { startNewBusinessCase } = this.props.actions;
        startNewBusinessCase();
      } else if (productType === 'FFWD') {
        const { getFFWDCustomerData } = this.props.actions;
        getFFWDCustomerData();
      } else if (productType === 'NGM') {
        const { getNGMCustomerData } = this.props.actions;
        getNGMCustomerData();
      } else if (productType === 'AMS') {
        const { getAMSCustomerData } = this.props.actions;
        getAMSCustomerData();
      } else if (productType === 'AMC') {
        const { getAMCCustomerData } = this.props.actions;
        getAMCCustomerData();
      } else if (productType === 'AMP') {
        const { getAMPCustomerData } = this.props.actions;
        getAMPCustomerData();
      } else if (productType === 'SCT') {
        const { getSCTCustomerData } = this.props.actions;
        getSCTCustomerData();
      }
    }
  }

  sessionRenewalPopupClose = () => {
    const { closeSessionPopRenewalPopup } = this.props.actions;
    closeSessionPopRenewalPopup();
  }

  render() {
    const logOutText = 'Log out';
    if (this.props.sessionRenewalComplete) {
      setTimeout(() => {
        const { closeSessionPopRenewalPopup } = this.props.actions;
        closeSessionPopRenewalPopup();
      }, 2000);
    }
    const sessionModalContent = customStyles => (
      <Modal
        isOpen={this.props.sessionRenewalInProgress || this.props.sessionRenewalComplete || this.props.sessionRenewalFailed}
        style={customStyles}
        onRequestClose={() => this.sessionRenewalPopupClose()}
      >
        {this.props.sessionRenewalInProgress &&
          <h2 className="text-center">{renderHTML(SESSION_RENEWAL_INPROGRESS_TEXT)}</h2>
        }
        {this.props.sessionRenewalComplete &&
          <h2 className="text-center ri-renewal-success">{renderHTML(SESSION_RENEWAL_COMPLETE_TEXT)}</h2>
        }
        {this.props.sessionRenewalFailed &&
        <React.Fragment>
          <div className="row">
            <div className="col-12">
              <h2 className="text-center ri-renewal-failure">{renderHTML(SESSION_RENEWAL_FAILED_TEXT)}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <Button
                className="button do-business"
                buttonText={logOutText}
                onClick={() => clearSessionStorage(CIP_LOGOUT_URL)}
              />
            </div>
          </div>
        </React.Fragment>
        }

      </Modal>
    );

    const { dataLoaded, hasError } = this.props;
    showHideElement(true, 'ri-right-hand-nav');

    if (dataLoaded && (this.props.sessionRenewalInProgress || this.props.sessionRenewalComplete || this.props.sessionRenewalFailed)) {
      return (
        <React.Fragment>
          {this.props.children}
          {sessionModalContent(customStylesDesktop)}
        </React.Fragment>
      );
    } else if (dataLoaded || hasError) {
      return (
        this.props.children
      );
    }
    return <Loader position="databootstrap" />;
  }
}

export default DataBootStrapView;

